import { useLocation } from 'react-router-dom';
import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
export function useRouteOfferingType() {
  const {
    pathname
  } = useLocation();
  return pathname.includes('/website') ? OfferingType.THEME : pathname.includes('/modules') ? OfferingType.MODULE : OfferingType.THEME;
}